var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("登录中...")]),_c('p',[_vm._v("如无法跳转请点击授权按钮")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.authM}},[_vm._v("授权")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }